import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  useMediaQuery,
  useTheme,
  CssBaseline,
  Button,
  Avatar,
} from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const Layout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { logout, isAuthenticated, currentUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Failed to log out", error);
    }
  };

  // Get display name or email for user info
  const getUserDisplayInfo = () => {
    if (!currentUser) return "";
    return currentUser.displayName || currentUser.email || "User";
  };

  return (
    <>
      <CssBaseline />
      <AppBar position='static' color='primary'>
        <Toolbar>
          <PhotoCameraIcon sx={{ mr: 2 }} />
          <Typography
            variant={isMobile ? "h6" : "h5"}
            component='div'
            sx={{ flexGrow: 1 }}
          >
            Webcam Viewer
          </Typography>

          {isAuthenticated && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {!isMobile && (
                <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
                  <Avatar
                    alt={getUserDisplayInfo()}
                    src={currentUser?.photoURL}
                    sx={{ mr: 1, width: 32, height: 32 }}
                  >
                    {!currentUser?.photoURL && <PersonIcon fontSize='small' />}
                  </Avatar>
                  <Typography variant='body2' sx={{ color: "inherit" }}>
                    {getUserDisplayInfo()}
                  </Typography>
                </Box>
              )}
              <Button
                color='inherit'
                onClick={handleLogout}
                startIcon={<LogoutIcon />}
              >
                {!isMobile && "Sign Out"}
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      <Container maxWidth='lg' sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ py: 2 }}>{children}</Box>
      </Container>

      <Box
        component='footer'
        sx={{
          py: 3,
          px: 2,
          mt: "auto",
          backgroundColor: (theme) => theme.palette.grey[200],
        }}
      >
        <Container maxWidth='lg'>
          <Typography variant='body2' color='text.secondary' align='center'>
            © {new Date().getFullYear()} Webcam Viewer
          </Typography>
        </Container>
      </Box>
    </>
  );
};

export default Layout;
